/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { ChangeEvent, useEffect, useState } from 'react'
import { MdCheck } from 'react-icons/md'
import { Grid } from '@material-ui/core'
import * as Yup from 'yup'

import Modal from 'shared/components/Modal'
import SnackBar from 'shared/components/SnackBar'
import { colors } from 'shared/styles/colors'
import { useFrotista } from 'modules/user/hooks/useFrotista'
import dimensions from 'shared/styles/dimensions'

import LoadingBackdrop from 'shared/components/LoadingBackdrop'
import { IListaBoletosDeposito } from 'modules/pagamentos/domain/usecases/ListaBoletosDeposito'
import { IBoletoDepositoResponse } from 'modules/pagamentos/domain/entities/IBoletoDepositoResponse'
import iconDocumento from 'shared/assets/icons/documento.svg'
import {
  ContainerModal,
  Icon,
  IconDocumento,
  TextModal,
  Title,
  Text,
  TitleArea,
  ContainerNoItems,
} from './styles'
import Boleto from './components/Boleto'
import { IBaixarPdfBoletoDeposito } from 'modules/pagamentos/domain/usecases/BaixarPdfBoletoDeposito'

export type TProps = {
  listaBoletosDeposito: IListaBoletosDeposito
  baixarPdfBoletoDeposito: IBaixarPdfBoletoDeposito
}

const GerenciarBoleto: React.FC<TProps> = ({
  listaBoletosDeposito,
  baixarPdfBoletoDeposito,
}) => {
  const { frotistaId, frotista } = useFrotista()

  const [boletos, setBoletos] = useState<IBoletoDepositoResponse[]>([])
  const [loading, setLoading] = useState(false)
  const [openSnackBar, setOpenSnackBar] = useState(false)
  const [openModalSucesso, setOpenModalSucesso] = useState(false)
  const [message, setMessage] = useState('')

  useEffect(() => {
    const init = async () => {
      try {
        setLoading(true)
        const response = await listaBoletosDeposito.execute(frotistaId)
        setBoletos(response)
        setLoading(false)
      } catch (error) {
        setLoading(false)
        setOpenSnackBar(true)
        setMessage(
          'Problemas ao consultar os boletos, tente novamente mais tarde',
        )
      }
    }
    init()
  }, [frotista, listaBoletosDeposito, frotistaId])

  return (
    <>
      {loading && <LoadingBackdrop open={loading} color={colors.green} />}
      {boletos.length === 0 && (
        <ContainerNoItems>
          <IconDocumento src={iconDocumento} />
          <Title>Não há nenhum boleto gerado</Title>
          <Text>Quando você gerar boletos, eles vão aparecer aqui.</Text>
        </ContainerNoItems>
      )}
      {boletos.map(boleto => (
        <Boleto
          key={boleto.codigo_de_barras}
          boleto={boleto}
          baixarPdfBoletoDeposito={baixarPdfBoletoDeposito}
        />
      ))}
    </>
  )
}

export default GerenciarBoleto
